import { createStore } from 'vuex'

export default createStore({
  state: {
    images: []
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
